import { Coordinate } from '@types'
import { Vector3 } from 'three'

export default (c: Coordinate) => {
  return new Vector3(c.x, c.y, c.z)
}

